import { clsx } from 'clsx';
import type { ProjectStatus, Decision } from '../../types';

type StatusType = ProjectStatus | Decision;

interface StatusBadgeProps {
  status: StatusType;
}

const statusConfig: Record<StatusType, { label: string; borderColor: string; bgColor: string }> = {
  // Decision statuses
  GREEN: {
    label: 'Green Light',
    borderColor: 'border-action',
    bgColor: 'bg-action/20',
  },
  CONDITIONAL: {
    label: 'Conditional',
    borderColor: 'border-amber-500',
    bgColor: 'bg-amber-500/20',
  },
  HOLD: {
    label: 'Hold',
    borderColor: 'border-wolf-500',
    bgColor: 'bg-wolf-500/20',
  },
  PASS: {
    label: 'Pass',
    borderColor: 'border-red-500',
    bgColor: 'bg-red-500/20',
  },
  BLOCKED: {
    label: 'Blocked',
    borderColor: 'border-red-600',
    bgColor: 'bg-red-600/20',
  },
  // Project statuses
  DRAFT: {
    label: 'Draft',
    borderColor: 'border-wolf-500',
    bgColor: 'bg-wolf-500/20',
  },
  PENDING_EVALUATION: {
    label: 'Evaluating',
    borderColor: 'border-yellow-500',
    bgColor: 'bg-yellow-500/20',
  },
  AI_EVALUATED: {
    label: 'AI Evaluated',
    borderColor: 'border-blue-500',
    bgColor: 'bg-blue-500/20',
  },
  EVALUATION_FAILED: {
    label: 'Eval Failed',
    borderColor: 'border-orange-500',
    bgColor: 'bg-orange-500/20',
  },
  UNDER_REVIEW: {
    label: 'Under Review',
    borderColor: 'border-purple-500',
    bgColor: 'bg-purple-500/20',
  },
  CONSENSUS_REACHED: {
    label: 'Consensus',
    borderColor: 'border-action',
    bgColor: 'bg-action/20',
  },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-1 font-mono text-xs uppercase tracking-wide border',
        config.borderColor,
        config.bgColor,
        'text-wolf-100'
      )}
    >
      {config.label}
    </span>
  );
}
